import * as React from "react";
import { Grid } from "@mui/material";
import MainTheme from "../mainTemplate";
import Title from "../../utilities/title";
import Label from "../../utilities/label";
import Input from "../../utilities/input";
import customerProfileDomainpdf from "../../assets/Customer Profile Domain Creation Steps.pdf";
import GuideForm from "../GuidePopUp/guidePopUp";
// import { Info } from "lucide-react";
import {validateRoleArn, validateAwsAccountNumber, validateInstanceId, removeRSpacefromString, removeLSpaceFromString, removeSpaceInBetween}from "../../preDefinedFunctions/inputFieldValidations.js"
import "./claimPhoneNumber.css";
import { awsDetailsContext } from "../../context";
import ModalForm from "../../utilities/modal";
import { useNavigate } from "react-router-dom";
import { handleEnterKey } from "../../preDefinedFunctions/inputFieldValidations";

// import FAQPage from "./FAQPage"
// Default fallback
const INITIAL_AWS_DETAILS = {
  AwsAccountNumber: "",
  AwsRegion: "",
  InstanceId: "",
  RoleArn: "",
  CustomerProfileDomain: "",
};

const AwsDetails = () => {
  const context = React.useContext(awsDetailsContext);
  let navigate = useNavigate();
  // Get initial values from context or fallback
  const initialDetails =
    typeof context === "function" ? context() : context || INITIAL_AWS_DETAILS;

  const [awsDetails, setawsDetails] = React.useState(initialDetails);

  const [errorMessages, setErrorMessages] = React.useState({
    AwsAccountNumber: "",
    AwsRegion: "",
    InstanceId: "",
    RoleArn: "",
    CustomerProfileDomain: "",
  });
  const awsAccountDetailsContext= React.useContext(awsDetailsContext)
  const [openGuideForm, setOpenGuideForm] = React.useState(false);
    const openGuideLink = () => {
    setOpenGuideForm(true);
  };
  // const instanceIdRef = React.useRef(null);
    // const roleArnRef = React.useRef(null);
  // const awsRegionRef = React.useRef(null);
  // const customerProfileDomainRef = React.useRef(null);
    // const loginButtonRef = React.useRef(null);

    const handleCloseGuideForm = () => {
    setOpenGuideForm(false);
  };
const handleInputChange = (e) => {
  const { id, value } = e.target;

  setawsDetails((prev) => ({
    ...prev,
    [id]: value,
  }));


  setErrorMessages((prev) => {
    // If field is empty → required message 
    if (value.trim() === "") {
      return {
        ...prev,
        [id]: `${id.replace(/([A-Z])/g, " $1")} is required`,
      };
    }

    // Special case: RoleArn → run regex validation
    if (id === "RoleArn") {
      const LefttrimmedResult = removeLSpaceFromString(value);
  setawsDetails((prev) => ({
      ...prev,
      [id]: LefttrimmedResult.value,
    }));

       const trimmedResult = removeRSpacefromString(LefttrimmedResult.value);
  setawsDetails((prev) => ({
      ...prev,
      [id]: trimmedResult.value,
    }));

      const result = validateRoleArn(trimmedResult.value);
      return {
        ...prev,
        [id]: !result.isValid
          ? result.message || "Please enter a valid Role Arn"
          : "",
      };
    }



    if (id === "AwsAccountNumber") {
      const LefttrimmedResult = removeLSpaceFromString(value);
  setawsDetails((prev) => ({
      ...prev,
      [id]: LefttrimmedResult.value,
    }));

       const trimmedResult = removeRSpacefromString(LefttrimmedResult.value);
  setawsDetails((prev) => ({
      ...prev,
      [id]: trimmedResult.value,
    }));

      const result = validateAwsAccountNumber(trimmedResult.value);
      return {
        ...prev,
        [id]: !result.isValid
          ? result.message || "Please enter a valid Account Number"
          : "",
      };
    }

    if (id === "InstanceId") {
      const LefttrimmedResult = removeLSpaceFromString(value);
  setawsDetails((prev) => ({
      ...prev,
      [id]: LefttrimmedResult.value,
    }));

      const trimmedResult = removeRSpacefromString(LefttrimmedResult.value);
  setawsDetails((prev) => ({
      ...prev,
      [id]: trimmedResult.value,
    }));
  
      const result = validateInstanceId(trimmedResult.value);
      return {
        ...prev,
        [id]: !result.isValid
          ? result.message || "Please enter a valid Account Number"
          : "",
      };
    }
    if (id === "CustomerProfileDomain") {
      const LefttrimmedResult = removeLSpaceFromString(value);
  setawsDetails((prev) => ({
      ...prev,
      [id]: LefttrimmedResult.value,
    }));
    const result = removeRSpacefromString(LefttrimmedResult.value);

    // 🔹 Always store the trimmed value
    setawsDetails((prev) => ({
      ...prev,
      [id]: result.value,
    }));
  }

  
  if (id === "AwsRegion") {
     const LefttrimmedResult = removeLSpaceFromString(value);
  setawsDetails((prev) => ({
      ...prev,
      [id]: LefttrimmedResult.value,
    }));
  //   const SpaceInBetweentrimmedResult = removeSpaceInBetween(LefttrimmedResult.value);
  // setawsDetails((prev) => ({
  //     ...prev,
  //     [id]: LefttrimmedResult.value,
  //   }));
    const result = removeRSpacefromString(LefttrimmedResult.value);
    setawsDetails((prev) => ({
      ...prev,
      [id]: result.value,
    }));
  }

    // Default: no error
    return {
      ...prev,
      [id]: "",
    };
  });
};



  const handleClick = () => {
    navigate("/Faq");
  };

  // Update global context only if it's not a function
  React.useEffect(() => {
    if (context) {
      context.awsAccountNumber = awsDetails.AwsAccountNumber;
      context.awsRegion = awsDetails.AwsRegion;
      context.instanceId = awsDetails.InstanceId;
      context.roleArn = awsDetails.RoleArn;
      context.domainName = awsDetails.CustomerProfileDomain;
    }
  }, [awsDetails.AwsAccountNumber, awsDetails.AwsRegion, awsDetails.InstanceId, awsDetails.RoleArn, awsDetails.CustomerProfileDomain]);

  return (
    <MainTheme>
      <Title title="Aws Account Details" />

      <div className="organization-details-section">
        <Grid container spacing={2} className="conatiner-section" />

        {/* Organization Name Field */}
        <Grid container className="company-name-container">
          <Grid item xs={12} className="organization-titles">
            <Label title="Aws Account Number" />
          </Grid>
          <Grid item md={9} xs={12} className="input-company-div">
            <Input
              type="text"
              required={true}
              id="AwsAccountNumber"
              label="Aws Account Number"
              value={awsDetails.AwsAccountNumber}
              handleOnChange={handleInputChange}
              // onKeyDown={(e)=> handleEnterKey(e,awsRegionRef)}
              placeholder="Enter your Aws Account Number"
              errorMessage={errorMessages.AwsAccountNumber}
            />
          </Grid>
        </Grid>

        {/* Genesys Region Field */}
        <Grid container className="company-name-container">
          <Grid item xs={12} className="organization-titles">
            <Label title="Aws Region" />
          </Grid>
          <Grid item md={9} xs={12} className="input-company-div">
            <Input
            // inputRef={awsRegionRef}
              type="text"
              required={true}
              id="AwsRegion"
              label="Aws Region"
              value={awsDetails.AwsRegion}
              handleOnChange={handleInputChange}
              // onKeyDown={(e)=> handleEnterKey(e,instanceIdRef)}
              placeholder="Enter Aws Region"
              errorMessage={errorMessages.AwsRegion}
            />
          </Grid>
        </Grid>

        {/* Instance Id Field */}
        <Grid container className="company-name-container">
          <Grid item xs={12} className="organization-titles">
            <Label title={
                <span className="customer-domain-label">
                  Instance Id
                  <a
                    // href={customerProfileDomainpdf}
                    label="Hello"
                    // download="Customer Profiles Domain Creation Steps.pdf"
                    className="info-icon"
                    // title="Download PDF"
                  >
                    <span className="info-circle" title="You can find the Instance ID in AWS Console → Amazon Connect → Your Instance → Instance ARN (last part)" aria-label="You can find the Instance ID in AWS Console → Amazon Connect → Your Instance → Instance ARN (last part)">i</span>
                  </a>
                </span>
              } />
          </Grid>
          {/* <Grid item xs={12} className="organization-titles">
            <Label title={
              <span className="instance-id-label">
                Instance Id
                <a
                  href={customerProfileDomainpdf}
                  download="Customer Profiles Domain Creation Steps.pdf"
                  className="info-icon"
                  title="Download PDF"
                >
                  <span className="info-circle" label='Download Pdf'>i</span>
                </a>
              </span>
            }
            />
          </Grid> */}
          <Grid item md={9} xs={12} className="input-company-div">
            <Input
            // inputRef={instanceIdRef}
              type="text"
              required={true}
              id="InstanceId"
              label="Instance Id"
              value={awsDetails.InstanceId}
              handleOnChange={handleInputChange}
              // onKeyDown={(e)=> handleEnterKey(e,roleArnRef)}
              placeholder="Enter Instance Id"
              errorMessage={errorMessages.InstanceId}
            />
          </Grid>
        </Grid>

        {/* Role Arn field */}
        <Grid container className="company-name-container">
          <Grid item xs={12} className="organization-titles">
            <Grid item xs={12} className="organization-titles">
              <div className="role-container">
  <Label title="Role Arn" />
  <div className="RoleArn">
    <p className="guide-style" onClick={openGuideLink}>
      How to set up role ARN
    </p>
  </div>
</div>
          </Grid>
            {/* <Label
              title={
                <span className='role-arn-label'>
                  Role Arn
                  <a
                    href={customerProfileDomainpdf}  // replace with the correct PDF link
                    download="Customer Profiles Domain Creation Steps.pdf"
                    className="info-icon"
                    title="Download PDF"
                  >
                    <span className="info-circle" label='Download Pdf'>i</span>
                  </a>
                </span>
              }
            /> */}
          </Grid>
          <Grid item md={9} xs={12} className="input-company-div">
            <Input
            // inputRef={roleArnRef}
              type="text"
              required={true}
              id="RoleArn"
              label="Role Arn"
              value={awsDetails.RoleArn}
              handleOnChange={handleInputChange}
              // onKeyDown={(e)=> handleEnterKey(e,customerProfileDomainRef)}
              placeholder="Enter Role Arn"
              errorMessage={errorMessages.RoleArn}
            />
          </Grid>
        </Grid>

        {/* Customer Profiles Domain Arn Field */}
        <Grid container className="company-name-container">
          <Grid item xs={12} className="organization-titles">
            {/* <Grid item xs={12} className="organization-titles">
            <Label title="Customer Profiles Domain" />
          </Grid> */}
            <Label

              title={
                <span className="customer-domain-label">
                  Customer Profiles Domain
                  <a
                    href={customerProfileDomainpdf}
                    download="Customer Profiles Domain Creation Steps.pdf"
                    className="info-icon"
                    title="Download PDF"
                  >
                    <span className="info-circle" label='Download Pdf'>i</span>
                  </a>
                </span>
              }
            />
          </Grid>
          <Grid item md={9} xs={12} className="input-company-div">
            <Input
            // inputRef={customerProfileDomainRef}
              type="text"
              required={true}
              id="CustomerProfileDomain"
              label="Customer Profile Domain"
              value={awsDetails.CustomerProfileDomain}
              handleOnChange={handleInputChange}
              // onKeyDown={(e)=> handleEnterKey(e,customerProfileDomainRef)}
              placeholder="Enter Customer Profile Domain"
              errorMessage={errorMessages.CustomerProfileDomain}
            />

            <ModalForm
          title={"Guidelines"}
          open={openGuideForm}
          handleClose={() => setOpenGuideForm(false)}
          showCloseIcon={true}
          component={<GuideForm handleClose={handleCloseGuideForm} />}
        />
          </Grid>
        </Grid>
        
      </div>
    </MainTheme>
  );
};

export default AwsDetails;
